/* eslint-disable dot-notation */
import type { AxiosResponse } from 'axios';
import axios from 'axios';
import cookies from '@/infrastructures/cookies';
import { AUTH_TOKEN_KEY } from '@/hooks/authorization';

/* eslint-disable camelcase */
export type EnrollmentType = {
  id: string;
  status?: string; // 'expired' | 'active' | etc.
  user?: {
    id: string;
    name: string;
    email: string;
  };
  current_cohort?: {
    id: string;
    name: string;
  };
};

export type UseEnrollmentReturn = {
  getEnrollment: (
    enrollmentId: string,
  ) => Promise<AxiosResponse<EnrollmentType>>;
};

function useEnrollment(): UseEnrollmentReturn {
  const baseURL = process.env.REACT_APP_BETRYBE_API_URL;
  const token = cookies.get(AUTH_TOKEN_KEY);
  const api = axios.create({
    baseURL,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  function getEnrollment(
    enrollmentId: string,
  ): Promise<AxiosResponse<EnrollmentType>> {
    return api.get<EnrollmentType>(
      `/enrollment-service/external/v2/enrollments/${enrollmentId}`,
    );
  }

  return { getEnrollment };
}

export default useEnrollment;
